<script setup lang="ts">
import { useRouter } from 'vue-router'
import { routes } from '@app/router/routes'
import TokenWalletTab from '../components/TokenWalletTab.vue'

const router = useRouter()

const onConnectWallet = () => {}
const onCheckActivationStatus = () => {}
const onEnableTrustline = () => {}
// Standalone /wallet/transactions page was removed — the fiat activity feed
// lives inside the wallet page's Recent Transactions card. Token-wallet flows
// are out of scope; route back to the wallet page on the token tab for now.
const onViewAllTransactions = () =>
  router.push({ path: routes.WALLET, query: { tab: 'token' } })
</script>

<template>
  <TokenWalletTab
    @connect-wallet="onConnectWallet"
    @check-activation-status="onCheckActivationStatus"
    @enable-trustline="onEnableTrustline"
    @view-all-transactions="onViewAllTransactions"
  />
</template>
